import { render, staticRenderFns } from "./Changepassword.vue?vue&type=template&id=168028f7&scoped=true"
import script from "./Changepassword.vue?vue&type=script&lang=js"
export * from "./Changepassword.vue?vue&type=script&lang=js"
import style0 from "./Changepassword.vue?vue&type=style&index=0&id=168028f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168028f7",
  null
  
)

export default component.exports